<template>
  <div v-if="histories.length > 0" class="history">
    <div class="container history-container" v-cloak>
      <h1 class="header-title">Истории ВПШ+</h1>
      <Swiper
        slides-per-view="auto"
        :space-between="8"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <SwiperSlide
          v-for="history in histories"
          :key="history.id"
          class="history__item"
          @click="
            () => {
              showStoriesModal(history);
            }
          "
        >
          <div
            class="history__image"
            :class="history.has_unwatched ? 'has-new' : ''"
          >
            <img
              v-if="history.poster"
              :src="history.poster"
              :alt="history.name"
            />
            <NoImage v-else />
          </div>
          <div class="history__name">{{ history.name }}</div>
        </SwiperSlide>
      </Swiper>
    </div>
    <StoriesModal
      :show="showStories"
      @modal="hideStoriesModal"
      :history="curHistory"
    />
  </div>
</template>

<script>
import { getHistorys } from '@/functions/API';
import { Swiper, SwiperSlide } from 'swiper/vue';
import StoriesModal from '@/components/modal/StoriesModal.vue';
import NoImage from '@/components/blocks/noimage/NoImage.vue';
import 'swiper/css';

export default {
  name: 'HistoryBlock',
  components: {
    Swiper,
    SwiperSlide,
    StoriesModal,
    NoImage,
  },
  data() {
    return {
      histories: [],
      showStories: false,
      curHistory: null,
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getHistorys((res) => {
        if (res !== false) {
          this.histories = [...new Set(res)];
        }
      });
    },
    showStoriesModal(targetHistory) {
      this.curHistory = targetHistory;
      this.showStories = true;
      this.getData();
      const body = document.getElementsByTagName('body')[0];
      if (body) {
        body.classList.add('fix');
      }
    },
    hideStoriesModal() {
      this.curHistory = null;
      this.showStories = false;
      this.getData();
      const body = document.getElementsByTagName('body')[0];
      if (body) {
        body.classList.remove('fix');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.history {
  margin-bottom: 28px;
  .header {
    &-title {
      color: var(--color-black);
      text-align: left;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
  &__item {
    width: 68px;
    cursor: pointer;
    * {
      user-select: none;
    }
  }
  &__image {
    width: 68px;
    height: 68px;
    min-width: 68px;
    max-height: 68px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-gray-light);
    border: 2px solid transparent;
    padding: 2px;
    img,
    svg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
    }
    svg {
      width: 80%;
      height: 80%;
    }
    &.has-new {
      border: 2px solid var(--color-blue);
    }
  }
  &__name {
    color: var(--color-gray);
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 11px;
    text-align: center;
    margin-top: 8px;
  }
  .swiper {
    overflow: visible;
  }
}
</style>
